
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { IApiIssue, IApiGetIssueListParams, IApiCreateIssueData, IApiUpdateIssueData } from './issue-service.types';
import { IApiPagingParams, IApiPage } from '../paging/paging-service.types';

const DocApiBaseUrl = `/doc-api`;

export const getIssueList = (params: IApiPagingParams<IApiGetIssueListParams>) => {
    return axios.get<IApiPage<IApiIssue>>(`${DocApiBaseUrl}/issue`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const getIssueByKey = (issueKey: string) => {
    return axios.get<IApiIssue>(`${DocApiBaseUrl}/issue/${issueKey}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const createIssue = (issue: IApiCreateIssueData) => {
    return axios.post(`${DocApiBaseUrl}/issue`, issue)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const updateIssue = (issueKey: string, data: IApiUpdateIssueData) => {
    return axios.put(`${DocApiBaseUrl}/issue/${issueKey}`, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const deleteIssueByKey = (issueKey: string) => {
    return axios.delete(`${DocApiBaseUrl}/issue/${issueKey}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

